import React from 'react';
import { getPasswordChecks, getPasswordStrength } from '../../utils/passwordStrength';

const PasswordStrengthMeter = ({ password = '' }) => {
  const strength = getPasswordStrength(password);
  const checks = getPasswordChecks(password);
  const percent = password ? (strength.score / 5) * 100 : 0;

  return (
    <div className="mt-2 space-y-2">
      <div className="h-2 w-full rounded-full bg-gray-200 overflow-hidden">
        <div
          className={`h-full transition-all duration-300 ${strength.color}`}
          style={{ width: `${percent}%` }}
        />
      </div>
      {password && (
        <p className="text-xs font-medium text-gray-600">
          Strength: <span className="font-semibold">{strength.label}</span>
        </p>
      )}
      <ul className="space-y-1">
        {checks.map((check) => (
          <li
            key={check.label}
            className={`text-xs flex items-center gap-2 ${
              check.ok ? 'text-green-600' : 'text-gray-500'
            }`}
          >
            <i className={`fas ${check.ok ? 'fa-check-circle' : 'fa-circle'} text-[10px]`}></i>
            {check.label}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordStrengthMeter;
